import { Input, message, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { MakeApiCall } from "../../../../apis";
import { PropsFilter, RenderTable } from "../../../../config";
import { Wrapper } from "./style";

const LineItemsView = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchText, setSearchText] = useState("");

  const columns = [
    {
      title: "#",
      align: "center",
      render: (row) => {
        return (
          <div
            className="d-flex justify-content-center w-100"
            style={{ width: "100%" }}
          >
            {row?.key}
          </div>
        );
      },
    },

    {
      title: "Menu Item",
      dataIndex: "title",
      key: "title",
      filterIndex: "title",

      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },
    {
      title: "Top Level Heading",
      dataIndex: "top_level_heading",
      key: "top_level_heading",
      filterIndex: "top_level_heading",

      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },
    {
      title: "Level 2nd Heading",
      dataIndex: "level_2nd_heading",
      key: "level_2nd_heading",
      filterIndex: "level_2nd_heading",

      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },
    {
      title: "Level 3rd Heading",
      dataIndex: "level_3rd_heading",
      key: "level_3rd_heading",
      filterIndex: "level_3rd_heading",

      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },
    {
      title: "Level 4th Heading",
      dataIndex: "level_4th_heading",
      key: "level_4th_heading",
      filterIndex: "level_4th_heading",

      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },
    {
      title: "Level 5th Heading",
      dataIndex: "level_5th_heading",
      key: "level_5th_heading",
      filterIndex: "level_5th_heading",

      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },
    {
      title: "Line Item Heading",
      dataIndex: "line_item_heading",
      key: "line_item_heading",
      filterIndex: "line_item_heading",

      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },
    {
      title: "Line Item Slug",
      dataIndex: "line_item_slug",
      key: "line_item_slug",
      filterIndex: "line_item_slug",

      render: (e, row) => {
        return <span>{e || "-"}</span>;
      },
    },
    {
      title: "Is Pending",
      dataIndex: "status",
      render: (e, row) => {
        return (
          <Tag color={e == 0 ? "orange" : "success"}>
            {e == 0 ? "Pending" : "Done"}
          </Tag>
        );
      },
    },

    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   key: "type",
    //   filterIndex: "type",
    // },
  ];

  const getList = async () => {
    const response = await MakeApiCall(
      `line-items?status=1`,
      "get",
      null,
      true
    );

    if (response?.status) {
      setList(
        response?.data?.map((d, i) => ({
          ...d,
          key: i + 1,
          title: d?.menuItem?.title || d?.top_level_heading,
        })) || []
      );
      setLoading(false);
    } else {
      setLoading(false);
      message.warning(response?.message);
    }
  };

  useEffect(() => {
    setLoading(true);
    getList();
    return () => {};
  }, []);

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  const downloadExcel = (data) => {
    const wb = XLSX.utils.book_new();
    message.destroy();
    const ws = XLSX.utils.json_to_sheet(
      data?.map((d, i) => ({
        ID: d?.key,
        "Menu Item": d?.title || d?.top_level_heading,
        "Top Level Heading": d?.top_level_heading,
        "Level 2nd Heading": d?.level_2nd_heading,
        "Level 3rd Heading": d?.level_3rd_heading,
        "Level 4th Heading": d?.level_4th_heading,
        "Level 5th Heading": d?.level_5th_heading,
        "Line Item Heading": d?.line_item_heading,
        "Line Item Slug": d?.line_item_slug,
        "Is Pending": d?.status == 1 ? "Pending" : "Done",
        // Heading: d?.heading,
        // Type: d?.type,
      }))
    );
    XLSX.utils.book_append_sheet(wb, ws, "Line Items");

    const excelBinaryString = XLSX.write(wb, {
      bookType: "xlsx",
      type: "binary",
    });

    const blob = new Blob([s2ab(excelBinaryString)], {
      type: "application/octet-stream",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Line Items.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    message.destroy();
  };

  const listFilter = list.filter((item) =>
    item?.line_item_heading?.toLowerCase().includes(searchText?.toLowerCase())
  );
  return (
    <Wrapper>
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            Line Items
            <span
              style={{
                fontSize: "13px",
                color: "#000000e0",
                fontWeight: 400,
                marginLeft: "4px",
                position: "relative",
                top: "1px",
              }}
            >
              {selectedRowKeys?.length
                ? `- ${selectedRowKeys?.length} Menu Item selected`
                : ""}
            </span>
          </div>
          <div className="card-toolbar">
            <div className="position-relative mr-4">
              <Input
                type="text"
                className="w-250px me-3"
                allowClear
                name="all_search"
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                value={searchText}
                placeholder="Search here..."
              />
            </div>
            <div
              style={{
                background: "#00B660",
                borderRadius: 6,
                padding: "8px 15px",
                cursor: "pointer",
              }}
              onClick={() => {
                downloadExcel(list);
              }}
            >
              <div
                style={{
                  color: "#FAFAFB",
                  fontSize: 13,

                  fontWeight: 500,
                  letterSpacing: 0.1,
                  wordWrap: "break-word",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  className="me-3"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 18.9656L13.3892 18.6653C13.8265 18.328 14.4544 18.409 14.7918 18.8463C15.1291 19.2836 15.0481 19.9115 14.6108 20.2489L12.6277 21.7787C12.5675 21.8274 12.5025 21.8682 12.4342 21.901C12.3808 21.928 12.309 21.9545 12.234 21.9725C12.1375 21.9951 12.0448 22.0033 11.953 21.9989C11.812 21.9924 11.6786 21.9567 11.5588 21.8976C11.4931 21.8654 11.4305 21.8257 11.3723 21.7787L9.38919 20.2489C8.9519 19.9115 8.87088 19.2836 9.20823 18.8463C9.54557 18.409 10.1735 18.328 10.6108 18.6653L11 18.9656V8.45711C11 7.90482 11.4477 7.45711 12 7.45711C12.5523 7.45711 13 7.90482 13 8.45711V18.9656ZM12.5 2C15.0609 2 17.2376 3.76105 17.8369 6.17236C20.2436 6.77356 22 8.95407 22 11.518C22 14.3327 19.8828 16.6868 17.1101 16.9939C16.5612 17.0547 16.0669 16.659 16.0061 16.1101C15.9453 15.5612 16.341 15.0669 16.8899 15.0061C18.6514 14.8109 20 13.3114 20 11.518C20 9.71741 18.6408 8.21401 16.8706 8.02783C16.4009 7.97843 16.0298 7.60718 15.9806 7.13748C15.7947 5.36183 14.2947 4 12.5 4C10.7037 4 9.20292 5.36415 9.01891 7.14171C8.96154 7.69596 8.46222 8.0964 7.90874 8.03205C7.77394 8.01638 7.63757 8.00847 7.5 8.00847C5.56748 8.00847 4 9.57926 4 11.518C4 13.3114 5.34862 14.8109 7.11011 15.0061C7.65903 15.0669 8.05473 15.5612 7.99392 16.1101C7.93311 16.659 7.43882 17.0547 6.88989 16.9939C4.11715 16.6868 2 14.3327 2 11.518C2 8.57497 4.30383 6.17018 7.20435 6.01629C7.85706 3.68561 9.99449 2 12.5 2Z"
                    fill="white"
                  />
                </svg>
                Export
              </div>
            </div>
          </div>
        </div>
        <div className="card-body p-0 pt-0 px-5">
          <Table
            dataSource={listFilter}
            columns={columns?.map((d) => ({
              ...d,
              className: d?.title === "#" ? "maxWidth-table" : "minWidth-table",
              ...(d?.filterIndex ? PropsFilter(d?.filterIndex) : ""),
              render: (props, row, index) => RenderTable(props, row, index, d),
            }))}
            fixed={true}
            sticky={{
              offsetHeader: "0px",
            }}
            loading={loading}
            rowKey={"key"}
            pagination={{
              size: "default",
              showSizeChanger: true,
              defaultPageSize: 100,
            }}
            rowClassName={(record, index) => {
              return index % 2 === 0 ? "even-row" : "odd-row";
            }}
            bordered
            size="small"
            scroll={{ x: "max-content", y: "calc(100vh - 410px)" }}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default LineItemsView;
